import normalizeEntity from '@flow/libs/normalized-redux/entity-normalizer';

const normalizedAutomationRules = normalizeEntity<
  Oneflow.AutomationRule,
  'automationRule',
  string[]
>({
  entity: 'automationRule',
});

export default normalizedAutomationRules;
